import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateProduct = async (placeId, productId, update) => {
  if (!placeId || !productId || !update) {
    console.log('NO PLACE ID');
    return;
  }
  
  await HTTP.post({
    path: `${uri.api}/place/${placeId}/product/${productId}/update`,
    data: update,
  });

};